
import React from 'react'

export interface ContentHeaderToolbarButton {
  label: string
  icon: string | JSX.Element
  onClick: any
  className?: string
  disabled?: boolean
  active?: boolean
}

interface Props {
  buttons: ContentHeaderToolbarButton[]
}

const ContentHeaderToolbar = ({ buttons }: Props) => {

  return (
    <div className="ul-widget__head-toolbar">
      <div className="text-right">
        {buttons.map((button: ContentHeaderToolbarButton, i: number) => (
          <button
            key={i}
            className={`btn btn-link btn-link-header ${button.className || ''} ${button.active ? 'active' : ''}`}
            onClick={button.onClick}
            disabled={button.disabled}
          >
            {button.icon} {button.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ContentHeaderToolbar
